if (!customElements.get("product-sibling-dropdown")) {
  customElements.define(
    "product-sibling-dropdown",
    class ProductSiblingDropdown extends HTMLElement {
      constructor() {
        super();
        this._onDocClick = this._onDocClick.bind(this);
        this._onKeydown = this._onKeydown.bind(this);
        this._onTriggerClick = this._onTriggerClick.bind(this);
      }

      connectedCallback() {
        this.trigger = this.querySelector("[data-product-sibling-dropdown-trigger]");
        this.panel = this.querySelector("[data-product-sibling-dropdown-panel]");
        this.dropdownIcon = this.trigger?.querySelector("svg");
        if (!this.trigger || !this.panel) return;

        this.trigger.addEventListener("click", this._onTriggerClick);
        this.panel.addEventListener("click", (e) => {
          if (e.target.closest("a[href]")) this.close();
        });
      }

      disconnectedCallback() {
        this.close();
        this.trigger?.removeEventListener("click", this._onTriggerClick);
      }

      _onTriggerClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.toggle();
      }

      toggle() {
        if (this._isOpen()) this.close();
        else this.open();
      }

      _isOpen() {
        return this.classList.contains("is-open");
      }

      open() {
        this.classList.add("is-open");
        this.panel.hidden = false;
        this.trigger.setAttribute("aria-expanded", "true");
        this.dropdownIcon?.classList.add("open");
        requestAnimationFrame(() => {
          document.addEventListener("click", this._onDocClick);
          document.addEventListener("keydown", this._onKeydown);
        });
      }

      close() {
        if (!this.panel || !this.trigger) return;
        this.classList.remove("is-open");
        this.panel.hidden = true;
        this.trigger.setAttribute("aria-expanded", "false");
        this.dropdownIcon?.classList.remove("open");
        document.removeEventListener("click", this._onDocClick);
        document.removeEventListener("keydown", this._onKeydown);
      }

      _onDocClick(e) {
        if (!this.contains(e.target)) this.close();
      }

      _onKeydown(e) {
        if (e.key === "Escape" || e.key === "Esc") this.close();
      }
    },
  );
}
